// frontend/src/routes/AdminRoute.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import API from "../helpers/API";
import AuthLoader from "../ui/Loader/AuthLoader";

export const AdminRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const authContext = useAuth();
  const [auth] = authContext;
  const { isAuthenticated, isInitialized, clearAuth, isTokenExpired } =
    authContext;
  const navigate = useNavigate();

  const checkAuthorization = useCallback(async () => {
    setIsLoading(true);

    // Check token expiration first
    if (isTokenExpired(auth.token)) {
      console.log("Token expired, redirecting to login");
      clearAuth();
      navigate("/Login", { replace: true });
      return;
    }

    try {
      // Check admin authorization
      const res = await API.get("/auth/adminRoute");
      setIsAuthorized(res.data?.ok === true);
    } catch (error) {
      console.error("Authorization error:", error);

      if (error.response?.status === 401) {
        clearAuth();
        navigate("/Login", { replace: true });
      } else if (error.response?.status === 403) {
        navigate("/", { replace: true }); // Redirect to home
        setIsAuthorized(false);
      } else {
        // Handle network errors without redirecting
        setIsAuthorized(true); // Trust client state temporarily
      }
    } finally {
      setIsLoading(false);
    }
  }, [auth.token, navigate, clearAuth, isTokenExpired]);

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      checkAuthorization();
    } else if (isInitialized && !isAuthenticated) {
      navigate("/Login", { replace: true });
    }
  }, [isInitialized, isAuthenticated, checkAuthorization, navigate]);

  if (!isInitialized || isLoading) {
    return <AuthLoader />;
  }

  return isAuthorized ? <Outlet /> : <AuthLoader />;
};
